import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'adres-bilgisi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--adres" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">ADRES BİLGİSİ</div>
        <div class="ab-adres gc-baslik-ana">{{ p()?.adres || 'Adres girilmedi' }}</div>
        <div class="ab-alt">
          <span class="ab-ilce">{{ p()?.ilce || '-' }}</span>
          <span class="ab-ayrac">/</span>
          <span class="ab-il">{{ p()?.il || '-' }}</span>
          @if (p()?.postaKodu) { <span class="ab-posta">{{ p().postaKodu }}</span> }
        </div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 55 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #0284c7; --accent-rgb: 2,132,199; }
    .ab-adres { font-size: 11px; color: var(--py-metin, #e2e8f0); line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .ab-alt { display: flex; align-items: center; gap: 4px; margin-top: 4px; }
    .ab-ilce, .ab-il { font-size: 12px; font-weight: 700; color: #38bdf8; }
    .ab-ayrac { font-size: 10px; color: var(--py-metin-ikincil, #64748b); }
    .ab-posta { font-size: 8px; font-weight: 600; letter-spacing: .08em; padding: 2px 6px; border-radius: 2px; color: #fff; background: rgba(2,132,199,0.3); margin-left: auto; }
  `],
})
export class AdresBilgisiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
}
